<template>
    <v-dialog v-model="isActive" width="500" scrollable transition="dialog-top-transition">
        <v-card flat>
            <v-card-text class="d-flex flex-row justify-center ma-0">
                <v-icon color="orange darken-2" size="120" class="mt-3">mdi-alert-circle-outline</v-icon>
            </v-card-text>
            <v-card-title class="justify-center text-h6 mb-2 font-weight-bold primary--text">
                INFORMACIÓN LABORAL
            </v-card-title>
            <v-card-text class="d-flex flex-column align-center">
                <div class="d-inline-flex black--text mb-1">
                    <div class="mr-2 font-weight-regular text-body-1 text-black">
                        EMPLEADOR:
                    </div>
                    <div class="text-body-1 font-weight-bold">
                        {{ opcionNivelAfiliado.empleo }}
                    </div>
                </div>

                <div class="d-inline-flex black--text mb-1 ">
                    <div class="mr-2 font-weight-normal text-body-1">
                        EMPLEO:
                    </div>
                    <div class="text-body-1 font-weight-bold">
                        {{ opcionNivelAfiliado.empleoTipo }}
                    </div>
                </div>
                <div class="d-inline-flex black--text">
                    <div class="mr-2 font-weight-normal text-body-1">
                        FECHA DE INICIO:
                    </div>
                    <div class="text-body-1 font-weight-bold">
                        {{ formatDate(opcionNivelAfiliado.empleoDesde) }}
                    </div>
                </div>
                <v-card-text class="d-flex flex-column align-center justify-center">

                    <v-btn @click="repetirEmpleo" elevation='0' class="py-5 mb-2" color="primary" width="320px">
                        Si, es correcto
                    </v-btn>
                    <v-btn @click="noRepite" class="py-5" outlined color="primary" width="320px">
                        no, quiero actualizar la información
                    </v-btn>
                </v-card-text>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>


import { mapActions, mapGetters } from 'vuex'

export default {

    components: {

    },
    data() {
        return {
            isActive: false,
            icon: 'mdi-close',

            //TIPOEMPLEO
            empleoTipo: 'LIC. EN PSICOLOGIA',
        }
    },

    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado']),
        ...mapGetters('notificaciones', ['loading']),
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),

        //metodos de accion de dialogo
        cerrarDialogo() {
            // cierra el dialogo y elimina las variables almacenadas temporalmente
            // en el store

            //  this.refreshData()
            //se vacia el store itemEdit
            /*  if (this.itemSelected) {
                 this.vaciarItem()
             } */
            this.isActive = false

        },
        abrirDialogo() {
            this.isActive = true
        },
        /*         cargaFoto() {
                    this.$emit('cargadaFoto', true)
                    this.cerrarDialogo()
                    this.showSnack({
                        message: 'Archivo guardado correctamente',
                        type: '200'
                    })
                },
                 */
        descartar() {

            /*             this.capturado = false
            this.addFotoCarnet('')
            this.activarVideo()
            this.$refs.canvas.width = 0 */

        },
        noRepite() {
            this.$emit('repiteEmpleo', false)
            this.cerrarDialogo()
        },
        repetirEmpleo() {
            this.$emit('repiteEmpleo', true)
            this.cerrarDialogo()
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    },
    props: ['titulo']

}

</script>